export enum CampaignTypes {
  DIRECT = "direct",
  REFERRAL = "referral",
  TIME = "time",
}

export type CampaignTypeUnion = `${CampaignTypes}`;

export interface CampaignType {
  campaign: CampaignTypeUnion;
  descriptionText: string;
  label: string;
}
